// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2_JZK","label":"LabeledBox_label__elafJ"};